// src/components/layout/AppLayout.tsx
import { Outlet } from 'react-router-dom';
import { Ribbon } from '../ribbon/Ribbon';
import { Toaster } from 'react-hot-toast';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import { useSettingsLoader } from '../../hooks/useSettingsLoader';
import { SessionWarningModal } from '../ui/SessionWarningModal';

export function AppLayout() {
  useSettingsLoader();
  const { showWarning, secondsLeft, staySignedIn, doLogout } = useSessionTimeout();

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Ribbon />

      {/* Main workspace */}
      <main className="flex-1 animate-fade-up">
        <Outlet />
      </main>

      {/* Toast notifications */}
      <Toaster
        position="bottom-right"
        gutter={8}
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: 'Outfit, sans-serif',
            fontSize: '13px',
            borderRadius: '10px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          },
          success: {
            iconTheme: { primary: '#10b981', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />

      {/* Session warning overlay */}
      {showWarning && (
        <SessionWarningModal
          secondsLeft={secondsLeft}
          onStay={staySignedIn}
          onLogout={doLogout}
        />
      )}
    </div>
  );
}
